'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formatKeys = {
  MY: 'i18n.dateTime.monthAndYear',
  MD: 'i18n.dateTime.monthAndDay'
};

exports.default = function (_ref) {
  var value = _ref.value,
      type = _ref.type,
      format = _ref.format,
      length = _ref.length;

  var momentValue = _I18n2.default.moment[type](value);
  var monthName = '';

  if (length === 's') {
    var monthKeys = Object.keys(_I18n2.default.translations.en.i18n.dateTime.shortForm.months);
    var shortMonthKey = monthKeys[momentValue.month()];
    monthName = _I18n2.default.text('i18n.dateTime.shortForm.months.' + shortMonthKey, {
      locale: _I18n2.default.locale
    });
  } else {
    monthName = momentValue.format('MMMM');
  }

  var options = {
    monthName: monthName,
    locale: _I18n2.default.locale
  };

  if (format === 'MD') {
    options.dayNumber = momentValue.date();
  } else {
    options.yearNumber = momentValue.year().toString();
  }

  return _I18n2.default.text(formatKeys[format], options);
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.441/js/internal/utils/formatAbstractDate.js
// module id = 94
// module chunks = 171